<template>
  <WidgetLayout>
    <MandateConfirmation />
  </WidgetLayout>
</template>

<script setup lang="ts">
import MandateConfirmation from '@/components/widget/payment/MandateConfirmation.vue';
import WidgetLayout from '@/layouts/WidgetLayout.vue';
</script>
